// extracted by mini-css-extract-plugin
export default {"container":"SponsorEventsForm_container__gTuCe"};